import * as React from "react";

import { cn } from "~/lib/utils";

/** P0-11 · Select — native select styled with tokens (accessible by default). */
export const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      "h-10 w-full rounded-md border border-border bg-surface px-3 text-sm text-fg outline-none transition-[box-shadow,border-color]",
      "focus:border-primary focus:ring-2 focus:ring-[var(--ring)]",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  >
    {children}
  </select>
));
Select.displayName = "Select";
